import React, { ForwardedRef, forwardRef } from "react"
import { Input as InputAntd, InputProps, InputRef } from "antd"

const Input = forwardRef((props: InputProps, ref: ForwardedRef<InputRef>) => {
  return <InputAntd {...props} ref={ref} />
})

export default React.memo(Input)
